import Vue from "vue";
import { scrollTop } from "./scroll.js";
export function setSelectType(item, defaultCheck) {
  Vue.set(item, "isClash", false); // 是否冲突，由于UI上的调整，多课包时只展示一个冲突提示，所以在最外层
  Vue.set(item, "clashMsg", ""); // 冲突时的提示信息
  /* 根据课包课程状态 处理课卡可选状态 selectType 1：可选，2：已选，3：禁选*/
  // status课包课程状态 1：正常，2：已报满，3：已购买，4：已停售，5：需诊断后报名，6：已下架，10：诊断未通过，11：待开售
  if ([5, 1].includes(item.status?.id)) {
    Vue.set(item, "selectType", defaultCheck ? 2 : 1);
  } else if ([2, 3, 4, 6, 10, 11].includes(item.status?.id)) {
    Vue.set(item, "selectType", 3);
    Vue.set(item, "originalSelectType", 3);
  }
  return item;
}
export function formatData(item, defaultCheck) {
  if (Array.isArray(item.package_info) && item.package_info.length === 0) {
    // 空课包 ——（联报名无课包状态）
    Vue.set(item, "isEmptyCourseCard", true);
  } else {
    Vue.set(item, "isEmptyCourseCard", false);
    Vue.set(item, "isClash", false); // 是否冲突，由于UI上的调整，多课包时只展示一个冲突提示，所以在最外层
    Vue.set(item, "clashMsg", ""); // 冲突时的提示信息
  }
  for (let packageItem of item.package_info) {
    setSelectType(packageItem, defaultCheck);
  }
  return item;
}

export function positionCard(_this) {
  // 闪烁 定位
  _this.timer = setTimeout(() => {
    // 推荐课程最外层id：recom-course-card-list
    // 原班课程最外层id：raw-course-card-list
    // tab_list最外层class：card-tab-wrap
    // package_info最外层class：select-card

    const { cardType, change_type, tab_list_index, package_info_index } =
      _this.$route.params;
    const id =
      cardType === "raw" ? "raw-course-card-list" : "recom-course-card-list";
    // 拿到某一个tab
    const tabListDom = document.getElementById(id).childNodes[tab_list_index];
    let dom = {};
    if (change_type === 3) {
      // 若change_type为3 会替换package_info中的某个课程，所以只闪烁某个课程
      dom =
        tabListDom.getElementsByClassName("select-card")[package_info_index];
    } else {
      // 若change_type为1 或 2 会替换整个package_info,所以整个区域闪烁
      dom = tabListDom.getElementsByClassName("select-card-wrap")[0];
    }
    const top = dom?.getBoundingClientRect().top;
    scrollTop(0, top - 20 > 0 ? top - 20 : 0);
    // document.documentElement.scrollTop = top - 20 > 0 ? top - 20 : 0;
    // 目前不闪烁了
    // dom.classList?.add("twinkle");

    // if (change_type === 1) {
    //   // 当更换原班课程时，推荐课程一同改变，所以一起闪烁
    //   const recomTabListDom = document.getElementById("recom-course-card-list");
    //   recomTabListDom
    //     .getElementsByClassName("select-card-wrap")[0]
    //     ?.classList?.add("twinkle");
    // }
  }, 800);
}

// 加价购商品勾选后价格可能发生变化，需要给加价购的商品一个新的价格，到手价展示这个新的价格
export function setBuyPrice(list, priceList) {
  const priceObj = {};
  priceList?.forEach((item) => {
    priceObj[`${item.product_id}_${item.product_type}`] = item.price;
  });
  list?.forEach((item) => {
    item.package_info?.forEach((packageItem) => {
      const price =
        priceObj[`${packageItem.product_id}_${packageItem.product_type}`];
      if (price !== undefined) {
        packageItem.price = {
          ...packageItem.price,
          buy_price: price,
        };
      }
    });
  });
}

// 类目属性  https://yach-doc-shimo.zhiyinlou.com/sheets/erAdPyGWp7tQKyAG/MODOC 《类目属性值》
const attribute = {
  test: {
    sever: 155, // 服务保障
    instalment: 154, // 分期付
    isLimit: 157, // 是否限购
    purchaseLimit: 158, // 限购数量
    InterestFree: 159, // 免息政策
    specs: 74, // 规格
    category_id: {
      xuexiji: 410, // 学习机
    },
  },
  online: {
    sever: 70,
    instalment: 65,
    isLimit: 67,
    purchaseLimit: 68,
    InterestFree: 66,
    specs: 71,
    category_id: {
      xuexiji: 96, // 学习机
    },
  },
}[process.env.OSS_ENV && process.env.OSS_ENV !== "test" ? "online" : "test"];

// 实物商品的一些数据需要根据后端返回的数据拼接好
export const transfromGoodsInfo = (list) => {
  if (!list) return [];
  return list.map((item) => {
    // 107 实物商品
    if (!item || item.product_type !== 107) {
      return item;
    }
    const attrInfo = item.attr_info || [];
    // 服务描述
    const serviceItem = attrInfo.find(
      (attr) => attr.attr_id === attribute.sever
    );
    const serviceValueInfo = serviceItem?.value_info || [];
    const serviceDesc = serviceValueInfo
      .slice(0, 3)
      .map((v) => v.value_name)
      .join("·");

    // 是否支持分期付款
    const instalmentItem = attrInfo.find(
      (attr) => attr.attr_id === attribute.instalment
    );
    const isInstalment =
      (instalmentItem?.value_info || [])[0]?.value_name === "是";

    // 是否限购
    const limitItem = attrInfo.find(
      (attr) => attr.attr_id === attribute.isLimit
    );
    const isLimit = (limitItem?.value_info || [])[0]?.value_name === "是";

    // 限购数量
    const purchaseLimitItem = attrInfo.find(
      (attr) => attr.attr_id === attribute.purchaseLimit
    );
    const purchaseLimit = (purchaseLimitItem?.value_info || [])[0]?.value_name;

    // 是否免息
    const interestFreeItem = attrInfo.find(
      (attr) => attr.attr_id === attribute.InterestFree
    );
    const interestFree = (interestFreeItem?.value_info || [])[0]?.value_name;

    // 商品标签
    const goodLabels = [];
    if (isLimit && purchaseLimit) {
      goodLabels.push(`限购${purchaseLimit}${purchaseLimitItem?.unit}`);
    }
    if (isInstalment && interestFree) {
      goodLabels.push(interestFree);
    }

    // 商品规格
    const specInfo = item.spec_info || [];
    const specItem = specInfo.find((spec) => spec.spec_id === attribute.specs);
    const specs = specItem?.spec_value_name;

    return {
      ...item,
      service_desc: serviceDesc,
      isInstalment,
      goodLabels,
      specs,
    };
  });
};
